import { render, staticRenderFns } from "./CategoryCardSkeleton.vue?vue&type=template&id=987f3670&"
import script from "./CategoryCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./CategoryCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCardSkeleton.vue?vue&type=style&index=0&id=987f3670&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports